
import styled from '@emotion/styled/macro';
import rem from '../../utils/rem/rem';


export const HeaderWrapper = styled.div`
  display: flex;
`;

export const StyledTitle = styled.div`
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray600};
  padding:${rem(4)} ${rem(8)};
`;

export const ModalBody = styled.div`
    display: flex;
    flex-flow: column nowrap;
    gap: ${rem(16)};
`

export const Text = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray900};
`

export const ErrorText = styled(Text)`
  color: ${({ theme }) => theme.colors.red};
`

export const ButtonRow = styled.div`
    display: flex;
    flex-flow: row nowrap;
    gap: ${rem(16)};
`

export const ReverseButtonRow = styled(ButtonRow)`
  flex-flow: row-reverse nowrap;
`